export function getProductEnrichmentInitialState() {
    return {
        products: [],
        isLoading: false,
        error: null,
        productId: undefined,
        placementIds: [],
    };
}
